import type { VuetifyBreakpoint } from '../models/vuetify-breakpoint.model';

export const vuetifyBreakpointConfig: VuetifyBreakpoint = {
  xs: 600,
  sm: 960,
  md: 1280,
  lg: 1920,
  xl: 2560
};
